import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { selectors as settingsSelectors, actions as settingsActions } from "reducers/settings";
import * as i18nUtils from "util/i18n";
import * as configUtils from "util/config";
import InfoModal from "pages/_components/InfoModal";
import { bool, string } from "prop-types";

/* global process */
const APP_VERSION = process.env.REACT_APP_VERSION;

const NewVersionApplication = ({ versionApi, forceUpdate }) => {
    const dispatch = useDispatch();

    const [playStoreUrl, setPlayStoreUrl] = useState(null);
    const [appStoreUrl, setAppStoreUrl] = useState(null);
    const [displayModal, setDisplayModal] = useState(false);

    useEffect(() => {
        dispatch(settingsActions.getApplicationVersion());

        const iosID = configUtils.get("client.app.market.iosId", "bibank/id1536486674");
        const androidID = configUtils.get("client.app.market.androidId", "com.technisys.bibank.mobile");
        const playStoreURL = `${configUtils.get(
            "store.android.url",
            "https://play.google.com/store/apps/details?id=ANDROID_APP_ID&hl=en_US&pli=1",
        )}`.replace("ANDROID_APP_ID", androidID);
        const appStoreURL = `${configUtils.get("store.ios.url", "https://apps.apple.com/ar/app/")}${iosID}`;

        setPlayStoreUrl(playStoreURL);
        setAppStoreUrl(appStoreURL);
    }, []);

    // Returns 1 if v2 is smaller, -1 if v1 is smaller, 0 if are equal
    const versionCompare = (v1, v2) => {
        const version1 = v1.split(".").map(Number);
        const version2 = v2.split(".").map(Number);

        const length = Math.max(version1.length, version2.length);

        for (let i = 0; i < length; i++) {
            const num1 = i < version1.length ? version1[i] : 0;
            const num2 = i < version2.length ? version2[i] : 0;

            if (num1 > num2) return 1;
            if (num2 > num1) return -1;
        }

        return 0;
    };

    useEffect(() => {
        setDisplayModal(versionApi && versionCompare(versionApi, APP_VERSION) === 1 ? forceUpdate : false);
    }, [versionApi, forceUpdate]);

    const goToMarket = () => {
        console.log("window.cordova ", window.cordova);
        if (window.cordova) {
            const { platformId } = window.cordova;
            console.log("platform ", platformId);
            if (platformId) {
                if (platformId === "ios") {
                    try {
                        window.cordova.InAppBrowser.open(appStoreUrl, "_system", "location=no");
                    } catch (error) {
                        console.log("error al abrir url ", error);
                    }
                } else {
                    window.open(playStoreUrl, "_system");
                }
            }
        } else {
            window.open(playStoreUrl, "_system");
        }
    };

    return (
        <>
            {displayModal && (
                <InfoModal
                    noCancelButton
                    bodyInfoText="texto"
                    modalSubtitle={i18nUtils.get("app.newVersion.title", "Actualización disponible")}
                    useScroll
                    body={() => (
                        <p>
                            {i18nUtils.get(
                                "app.newVersion.description",
                                "Está disponible la versión #{version}, para poder continuar por favor actualice la aplicación. ",
                                { version: versionApi },
                            )}
                        </p>
                    )}
                    handlerAccept={() => goToMarket()}
                    acceptLabel="global.update"
                    centered
                />
            )}
        </>
    );
};
NewVersionApplication.propTypes = {
    versionApi: bool.isRequired,
    forceUpdate: string.isRequired,
};
const mapStateToProps = (state) => ({
    versionApi: settingsSelectors.getVersion(state),
    forceUpdate: settingsSelectors.getForceUpdate(state),
});

export default connect(mapStateToProps)(NewVersionApplication);
